import { render, staticRenderFns } from "./rotate-cw-redo.svg?vue&type=template&id=1fa0a12b"
var script = {}


/* normalize component */
import normalizer from "!../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports